import moment, { type DurationInputArg2 } from 'moment';
import { toNumber, percentChange, toFixed, toBig, type NumberLike } from '@repo/utils/calc';

export function getDiscountPercent(
  normalPrice: number | string,
  discountPrice: number | string,
  decimals = 2
) {
  if (
    !normalPrice ||
    !discountPrice ||
    toBig(normalPrice).eq('0') ||
    toBig(discountPrice).eq('0') ||
    [Infinity, -Infinity, NaN].includes(Number(normalPrice)) ||
    [Infinity, -Infinity, NaN].includes(Number(discountPrice))
  ) {
    return 0;
  }
  return toFixed(toBig(percentChange(normalPrice || 0, discountPrice)).times('-1'), decimals);
}

export function getDiscountPriceRaw(normalPrice: NumberLike, discount: NumberLike) {
  const val = toBig(normalPrice)
    .times(toBig(1).minus(toBig(discount).div('100')))
    .abs();

  return toNumber(val, true);
}

export function getDiscountPrice(normalPrice: NumberLike, discount: NumberLike) {
  return toBig(normalPrice)
    .times(toBig(1).minus(toBig(discount).div('100')))
    .abs()
    .toFixed(2);
}

export function getPriceMargin(price: number | string, buyPrice: NumberLike) {
  if (!parseFloat(String(price))) return 0;

  const val = toBig(price).minus(toBig(buyPrice)).div(toBig(price)).times('100');
  return toNumber(val, true);
}
